"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilters = exports.adjustBetsStatisticsList = exports.betsHistoryProviderSideEffects = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const sumBy_1 = __importDefault(require("lodash/sumBy"));
const keyBy_1 = __importDefault(require("lodash/keyBy"));
const map_1 = __importDefault(require("lodash/map"));
const slice_1 = require("../slice");
const types_1 = require("./types");
exports.betsHistoryProviderSideEffects = {
    betsHistoryPage: {
        onSuccess: slice_1.betsHistoryProviderActions.fetchHistoryBetsPageSuccess,
        onError: slice_1.betsHistoryProviderActions.fetchHistoryBetsPageError,
    },
};
const adjustBetsStatisticsList = (betsStatisticsList, currencies) => {
    // eslint-disable-next-line camelcase
    const { items: betsStatisticsItems } = betsStatisticsList;
    const totalAmount = (0, sumBy_1.default)(betsStatisticsItems, 'amount');
    const totalCount = (0, sumBy_1.default)(betsStatisticsItems, 'count');
    const betsStatisticsTotalItem = {
        amount: totalAmount,
        count: totalCount,
        key: types_1.BETS_STATISTICS_EXTRA_KEYS.TOTAL,
    };
    return {
        betsStatisticsEntries: (0, keyBy_1.default)([
            betsStatisticsTotalItem,
            ...betsStatisticsItems.map(({ amount, count, betType }) => ({
                amount,
                count,
                key: betType,
            })),
        ], 'key'),
        currencyIcon: (currencies === null || currencies === void 0 ? void 0 : currencies.symbol) || '',
    };
};
exports.adjustBetsStatisticsList = adjustBetsStatisticsList;
const getFilters = ({ dates, betsStatus, betsTypes, gameVendor, }) => {
    const { startDate, endDate } = dates;
    return {
        ...(betsStatus && { status: betsStatus }),
        ...(gameVendor && { gameVendor }),
        ...(betsTypes && { types: (0, map_1.default)(betsTypes, 'value') }),
        ...(startDate && {
            createdFrom: (0, dayjs_1.default)(startDate).format(),
            createdTo: startDate && endDate
                ? (0, dayjs_1.default)(endDate).endOf('date').format()
                : (0, dayjs_1.default)(startDate).endOf('date').format(),
        }),
    };
};
exports.getFilters = getFilters;
//# sourceMappingURL=index.js.map